import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class PaginationService {

  private _paginatorSource = new BehaviorSubject<number>(0);
  // Observable navItem stream
  paginator$ = this._paginatorSource.asObservable();
  // service command
  resetPage(number) {
    this._paginatorSource.next(number);
  }
}
